module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAGUlEQVQoz2NgIAf4rZ3/nxg8qmGoayAFAAAB4APUummR3AAAAABJRU5ErkJggg=="